module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-UltraBold.327d29e.woff2";